import http from "./httpService"
import config from "../components/common/config.json"

export function getTestimonials() {
  return http.get(config.testimonialApiEndpoint)
}
